import { render, staticRenderFns } from "./head2022.vue?vue&type=template&id=51803889&scoped=true"
import script from "./head2022.vue?vue&type=script&lang=js"
export * from "./head2022.vue?vue&type=script&lang=js"
import style0 from "./head2022.vue?vue&type=style&index=0&id=51803889&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51803889",
  null
  
)

export default component.exports